import _taggedTemplateLiteral from "/var/lib/jenkins/workspace/aws-PROD-deploy-react-form/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n\tvertical-align: middle;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n\tdisplay: grid;\n\tgrid-template-columns: max-content auto;\n\talign-items: center;\n\tmargin-top: ", ";\n\tmargin-bottom: ", ";\n\tgrid-column-gap: 1em;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import * as React from 'react';
import { Text } from '../text';
import { styled } from '../theme-provider';
var StyledListItem = styled.li.withConfig({
  displayName: "StyledListItem",
  componentId: "sc-112v5tu"
})(_templateObject(), function (props) {
  return props.gutter ? props.theme.size[props.gutter] : props.theme.size.static300;
}, function (props) {
  return props.gutter ? props.theme.size[props.gutter] : props.theme.size.static300;
});
var StyledFlexItem = styled.div.withConfig({
  displayName: "StyledFlexItem",
  componentId: "sc-1vgqn61"
})(_templateObject2());

var Marker = function Marker(props) {
  var _props$index = props.index,
      index = _props$index === void 0 ? 0 : _props$index,
      _props$isOrdered = props.isOrdered,
      isOrdered = _props$isOrdered === void 0 ? false : _props$isOrdered,
      _props$markerSize = props.markerSize,
      markerSize = _props$markerSize === void 0 ? 0 : _props$markerSize;
  return isOrdered ? React.createElement(Text, {
    bold: true
  }, index.toString().padStart(markerSize, '0'), " ") : React.createElement(Text, {
    bold: true
  }, "\u2014 ");
};

var convertPlainTextToTextComponent = function convertPlainTextToTextComponent(children) {
  if (typeof children === 'string') {
    return React.createElement(Text, null, children);
  }

  return children;
};

export var ListItem = function ListItem(props) {
  var children = props.children,
      index = props.index,
      _props$isOrdered2 = props.isOrdered,
      isOrdered = _props$isOrdered2 === void 0 ? false : _props$isOrdered2,
      gutter = props.gutter,
      markerSize = props.markerSize;
  return React.createElement(StyledListItem, {
    isOrdered: isOrdered,
    index: index,
    gutter: gutter,
    markerSize: markerSize
  }, React.createElement(StyledFlexItem, null, React.createElement(Marker, {
    isOrdered: isOrdered,
    index: index,
    markerSize: markerSize
  }, children)), React.createElement(StyledFlexItem, null, convertPlainTextToTextComponent(children)));
};